import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { qformat, DATE_FORMATS, formatRelativeCompact } from "views_shared/app/javascript/utils/dateFormatters";

// Compact relative datetime ("in 30m", "2d ago") with the absolute time
// ("Jun 1, 2026, 3:37 PM") exposed via the title attribute on hover.
// Ticks every TICK_MS so the relative text stays current without a page
// refresh — half-minute granularity is invisible to the user but cheap.
const TICK_MS = 30_000;

function RelativeTime({ date }) {
  const [, setNow] = useState(() => Date.now());

  useEffect(() => {
    const t = window.setInterval(() => setNow(Date.now()), TICK_MS);
    return () => window.clearInterval(t);
  }, []);

  if (!date) return null;
  return <span title={qformat(date, DATE_FORMATS.dateTime)}>{formatRelativeCompact(date)}</span>;
}

RelativeTime.propTypes = {
  date: PropTypes.string, // ISO8601
};

RelativeTime.defaultProps = {
  date: null,
};

export default RelativeTime;
